﻿import React from "react";
import {
    Featured_Project,
    Current_Project,
    Current_Project_Ellapsed_Time,
    Logged_In_User,
    InTime_User,
    Customer,
    Status_Update_Type,
    Time_Log_Entry,
    Prompt_Information_Type,
    Weeks_Timelog_Filter,
    Client_Website_Type,
    Client_Website_Warning_Type,
    Reminder
} from '@Util/Types';

export type context_type = {
    status_update: Status_Update_Type,
    set_status_update: React.Dispatch<React.SetStateAction<Status_Update_Type>>,
    weeks_timelog_filter: Weeks_Timelog_Filter,
    set_weeks_timelog_filter: React.Dispatch<React.SetStateAction<Weeks_Timelog_Filter>>,
    featured_projects: Featured_Project[],
    current_project: Current_Project,
    current_project_ellapsed_time: Current_Project_Ellapsed_Time,
    logged_in_user: Logged_In_User,
    intime_users: InTime_User[],
    customers: Customer[],
    todays_time_log: Time_Log_Entry[],
    weeks_time_log: Time_Log_Entry[],
    months_time_log: Time_Log_Entry[],
    prompt_information: Prompt_Information_Type,
    set_prompt_information: React.Dispatch<React.SetStateAction<Prompt_Information_Type>>,
    client_websites: Client_Website_Type[],
    client_websites_with_warnings: Client_Website_Warning_Type[],
    sidebar_visible: boolean,
    set_sidebar_visible: React.Dispatch<React.SetStateAction<boolean>>,
    bulletin_board: string,
    reminders: Reminder[],
    overdue_reminders: Reminder[],

    // API FUNCTIONS
    create_default_entry: (id: number) => Promise<void>,
    start_time: (id: number) => Promise<void>,
    stop_time: (id: string) => Promise<void>,
    fetch_customers: () => Promise<void>,
    fetch_this_weeks_timelog: () => Promise<void>,
    fetch_this_months_timelog: () => Promise<void>,
    fetch_bulletin_board: () => Promise<void>,
    fetch_reminders: () => Promise<void>,
    delete_time_object: (id: number) => Promise<void>,
    update_time_object: (entry_id: number, start_time: string, end_time: string, project_id: number) => Promise<void>,
    split_time_object: (id: string) => Promise<void>,
    align_time_object: (id: string, mode: string) => Promise<void>
}

export default React.createContext<context_type>(undefined);